import * as React from "react";
import { useNavigate } from "react-router-dom";

interface TitleProps {
  title: string;
  explanation: React.ReactNode | string;
  backbutton?: boolean;
  titleSuffix?: React.ReactNode;
  backOnclick?: () => void;
  children?: React.ReactNode;
}

const ExplainTitle = React.memo<TitleProps>(
  ({ title, explanation, children, backbutton = true, backOnclick, titleSuffix }) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
      if (backOnclick) {
        backOnclick();
      } else {
        navigate(-1);
      }
    };

    return (
      <div className="flex-row-between w-full mb-[28px]">
        <div className="flex-row w-full">
          {backbutton && (
            <div
              className="border border-[#C7C7CC] w-[48px] h-[48px] rounded-1 cursor-pointer flex justify-center items-center mr-[28px]"
              onClick={handleBackClick}
            >
              <img src="/static/icons/icon_arrow_left.svg" alt="back_button" />
            </div>
          )}
          <div className="flex-1 w-full">
            <div className="flex-row w-full">
              <h2 className="text-[24px] whitespace-nowrap ">{title.length > 35 ? `${title.slice(0, 35)}...` : title}</h2>
              {titleSuffix ?? null}
            </div>
            <div className="text-[14px] text-[rgba(0,0,0,0.6)]">{explanation}</div>
          </div>
        </div>
        {children ?? <div>{children}</div>}
      </div>
    );
  }
);

ExplainTitle.displayName = "ExplainTitle";
export default ExplainTitle;
